import {
  ExportedMessageRepository,
  fromThreadMessageLike,
  MessageStatus,
  ThreadMessage,
} from '@assistant-ui/core';
import { fromAgUiMessages } from '@assistant-ui/react-ag-ui';
import type { ThreadDetail } from '@/experiences/sales-portal/domain/superintelligence/blocs/services/thread-api';

const COMPLETE: MessageStatus = { reason: 'unknown', type: 'complete' };

const AG_UI_METADATA_NAMESPACE = 'agui';

type HydratableThread = Pick<
  ThreadDetail,
  'interrupts' | 'messages' | 'threadId'
>;

export const hydrateThreadMessages = (
  thread: HydratableThread,
): ThreadMessage[] => {
  const messages = fromAgUiMessages(thread.messages).map((like, index) =>
    fromThreadMessageLike(like, `${thread.threadId}-${index}`, COMPLETE),
  );
  if (thread.interrupts.length === 0) {
    return messages;
  }
  for (let index = messages.length - 1; index >= 0; index--) {
    const message = messages[index];
    if (!message || message.role !== 'assistant') {
      continue;
    }
    const custom = message.metadata.custom;
    const agui = custom[AG_UI_METADATA_NAMESPACE];
    messages[index] = {
      ...message,
      metadata: {
        ...message.metadata,
        custom: {
          ...custom,
          [AG_UI_METADATA_NAMESPACE]: {
            ...(typeof agui === 'object' && agui !== null ? agui : {}),
            interrupts: thread.interrupts,
          },
        },
      },
      status: { reason: 'interrupt', type: 'requires-action' },
    };
    break;
  }
  return messages;
};

export const toMessageRepository = (
  messages: readonly ThreadMessage[],
): ExportedMessageRepository => ({
  headId: messages[messages.length - 1]?.id ?? null,
  messages: messages.map((message, index) => ({
    message,
    parentId: index === 0 ? null : (messages[index - 1]?.id ?? null),
  })),
});
